import { toAtlasCountryCode } from './toAtlasCountryCode';
import { type LocalizationContext } from '$lib/i18n';
import logger from '$lib/logger';
import type { Figure } from '$lib/server/figures/types';

export function getLocalizedInfo(
  figureData: Figure,
  locale: LocalizationContext,
): Figure['localization'][number][string] {
  const countryCode = toAtlasCountryCode(locale.countryCode);
  const localeSpecificInfo = figureData.localization.find(
    (localization) => localization[countryCode],
  )?.[countryCode];

  if (localeSpecificInfo) {
    return localeSpecificInfo;
  }
  logger().error(`Could not find localized info (${countryCode}) for figure: ${figureData.id}`);
  return {};
}
